import * as InsightsApi from '@bmai/insights-api-client';
import { ApiClientFactory } from './ApiClientFactory';

const configuration = new InsightsApi.Configuration(ApiClientFactory.createConfig('/_insights'));

export const insightsClient = ApiClientFactory.instantiateApis(InsightsApi, configuration);
